import Cross from "../../assets/icon/NewsIcons/MainAdmin/NewsCross";
import React, { useState } from "react";
import { axiosReq } from "../../commons/axiosReq";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DatePicker } from "zaman";

const portalOptions = [
    { value: "LinkedIn", label: "LinkedIn" },
    { value: "Indeed", label: "Indeed" },
    { value: "Company site", label: "Company site" },
    { value: "Other", label: "Other" },
];

const colourStyles = {
    control: (base) => ({ ...base, backgroundColor: "white" }),
    option: (base) => ({ ...base, backgroundColor: "white", color: "#000" }),
};

const fixNumber = (str) => {
    if (typeof str !== "string") return str;
    const persian = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabic = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    for (let i = 0; i < 10; i++) {
        str = str.replace(persian[i], i).replace(arabic[i], i);
    }
    return str;
};

const AddJobModal = ({ setShowModal, setRecheck, reCheck, onSaved, countries, language = "fa" }) => {
    const isEnglish = language === "en";
    const text = (fa, en) => isEnglish ? en : fa;
    const [snipper, setSnipper] = useState(false);
    const [showErrorModalStep1, setShowErrorModalStep1] = useState(false);
    const [error, setEroor] = useState();

    const [allValues, setAllValues] = useState({
        Title: "",
        Company: "",
        Location: "",
        Url: "",
        Portal: null,
        ContactEmail: "",
        Deadline: "",
        TagsCsv: "",
        CountryId: null,
    });
    const [allValuesError, setAllValuesError] = useState({
        Title: false,
        Company: false,
    });

    const blurHandler = (e) => {
        if (e.target) {
            if (e.target.value === "") {
                setAllValuesError({ ...allValuesError, [e.target.name]: true });
            }
        }
    };
    const changeHandler = (e) => {
        if (e.target) {
            if (e.target.value !== "") {
                setAllValuesError({ ...allValuesError, [e.target.name]: false });
            } else {
                setAllValuesError({ ...allValuesError, [e.target.name]: true });
            }
            setAllValues({ ...allValues, [e.target.name]: e.target.value });
        }
    };
    const addJob = async () => {
        setSnipper(true);
        var res = allFull(allValues);
        if (res) {
            let deadlineIso = null;
            if (allValues.Deadline) {
                try {
                    const d = new Date(allValues.Deadline);
                    deadlineIso = isNaN(d.getTime()) ? allValues.Deadline : d.toISOString();
                } catch {
                    deadlineIso = allValues.Deadline;
                }
            }
            const dataUser = await axiosReq("Job", "post", {
                Title: allValues.Title,
                Company: allValues.Company,
                Location: allValues.Location,
                Url: allValues.Url,
                Portal: allValues.Portal ? allValues.Portal.value : null,
                ContactEmail: allValues.ContactEmail,
                Deadline: deadlineIso,
                TagsCsv: allValues.TagsCsv,
                CountryId: allValues.CountryId ? allValues.CountryId.value : null,
            });
            if (dataUser?.status === 200 || dataUser?.status === 204 || dataUser?.status === 201) {
                setRecheck(!reCheck);
                setShowModal(false);
                setSnipper(false);
                onSaved && onSaved();
            } else {
                setEroor(isEnglish ? "We could not save this job. Please review the fields and try again." : dataUser?.data);
                setShowErrorModalStep1(true);
                setSnipper(false);
            }
        } else {
            setEroor(text("لطفا موارد خواسته شده را وارد نمایید", "Please complete the required fields."));
            setShowErrorModalStep1(true);
            setSnipper(false);
        }
    };

    const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        if (obj.Title === "") {
            updatedState.Title = true;
            setAllValuesError({ ...allValuesError, ...updatedState });
            result = false;
        }
        if (obj.Company === "") {
            updatedState.Company = true;
            setAllValuesError({ ...allValuesError, ...updatedState });
            result = false;
        }
        return result;
    };

    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength);
        }
    };

    return (
        <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none" dir={isEnglish ? "ltr" : "rtl"}>
                <div className="relative w-[50%] my-5 mx-auto ">
                    <div className="border-0 rounded-[20px] p-[25px] shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                        <div className="flex justify-between items-center border-b-2 pb-[25px] border-borderGray">
                            <p className="text-[15px] font-IRANYekanBold text-mainColor2">{text("افزودن شغل جدید", "Add a new job")}</p>
                            <button onClick={() => setShowModal(false)} aria-label="Close">
                                <Cross />
                            </button>
                        </div>

                        <div className="grid grid-cols-2 gap-2 w-full mt-[23px] mb-[43px]">
                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("عنوان", "Job title")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="Title"
                                    placeholder={text("عنوان را اینجا بنویسید", "Enter the job title")}
                                    value={allValues.Title}
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    onInput={maxLengthCheck}
                                    maxLength={200}
                                />
                                {allValuesError?.Title ? (
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        {text("لطفا عنوان را وارد نمایید!", "Job title is required.")}
                                    </span>
                                ) : null}
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("شرکت", "Company")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="Company"
                                    placeholder={text("شرکت را اینجا بنویسید", "Enter the company name")}
                                    value={allValues.Company}
                                    onChange={changeHandler}
                                    onBlur={blurHandler}
                                    onInput={maxLengthCheck}
                                    maxLength={200}
                                />
                                {allValuesError?.Company ? (
                                    <span className="flex items-center font-medium tracking-wide text-[#ff0000] text-xs ml-1">
                                        {text("لطفا شرکت را وارد نمایید!", "Company is required.")}
                                    </span>
                                ) : null}
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("موقعیت", "Location")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="Location"
                                    placeholder={text("موقعیت را وارد کنید", "Enter the location")}
                                    value={allValues.Location}
                                    onChange={changeHandler}
                                    onInput={maxLengthCheck}
                                    maxLength={200}
                                />
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("لینک", "Listing URL")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="Url"
                                    placeholder="https://..."
                                    value={allValues.Url}
                                    onChange={changeHandler}
                                    onInput={maxLengthCheck}
                                    maxLength={2000}
                                    dir="ltr"
                                />
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("پورتال", "Source")}</span>
                                <Select
                                    options={portalOptions}
                                    value={allValues.Portal}
                                    onChange={(val) => setAllValues({ ...allValues, Portal: val })}
                                    placeholder={text("انتخاب کنید", "Select a source")}
                                    isSearchable={true}
                                    styles={colourStyles}
                                />
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("ایمیل تماس", "Contact email")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="ContactEmail"
                                    placeholder={text("ایمیل را وارد کنید", "Enter the contact email")}
                                    value={allValues.ContactEmail}
                                    onChange={changeHandler}
                                    onInput={maxLengthCheck}
                                    maxLength={300}
                                    dir="ltr"
                                />
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("مهلت ارسال", "Application deadline")}</span>
                                <div className="border-[1px] border-borderGray rounded-[5px] px-2 flex items-center h-[35px]">
                                    {isEnglish ? <input type="date" className="w-full border-0 outline-none" value={allValues.Deadline} onChange={(event) => setAllValues({ ...allValues, Deadline: event.target.value })} /> : <DatePicker
                                        placeholder="تاریخ"
                                        onChange={(e) => {
                                            try {
                                                const parts = new Date(e.value).toLocaleDateString("fa-IR").split("/");
                                                const yy = fixNumber(parts[0]);
                                                const mm = fixNumber(parts[1]);
                                                const dd = fixNumber(parts[2]);
                                                setAllValues({
                                                    ...allValues,
                                                    Deadline: `${yy}/${mm.length === 1 ? "0" + mm : mm}/${dd.length === 1 ? "0" + dd : dd}`,
                                                });
                                            } catch {
                                                setAllValues({ ...allValues, Deadline: "" });
                                            }
                                        }}
                                    />}
                                </div>
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("تگ‌ها (با ویرگول)", "Tags (comma separated)")}</span>
                                <input
                                    className="h-[35px] focus:outline-lightGray border-[1px] border-borderGray text-[12px] font-IRANYekanNormal pr-[10px] rounded-[5px] placeholder-lightGray"
                                    type="text"
                                    name="TagsCsv"
                                    placeholder="tag1,tag2"
                                    value={allValues.TagsCsv}
                                    onChange={changeHandler}
                                    onInput={maxLengthCheck}
                                    maxLength={500}
                                    dir="ltr"
                                />
                            </div>

                            <div className="col-span-1 mb-[10px] flex flex-col">
                                <span className="text-[15px] font-IRANYekanBold mb-1">{text("کشور", "Country")}</span>
                                <Select
                                    options={countries}
                                    value={allValues.CountryId}
                                    onChange={(val) => setAllValues({ ...allValues, CountryId: val })}
                                    placeholder={text("انتخاب کشور", "Select a country")}
                                    isSearchable={true}
                                    styles={colourStyles}
                                    isClearable={true}
                                />
                            </div>
                        </div>

                        <div className="flex justify-center">
                            <button onClick={() => setShowModal(false)}>
                                <p className="text-[15px] font-IRANYekanBold mx-[12px]">{text("بستن", "Close")}</p>
                            </button>
                            <button
                                onClick={addJob}
                                className="h-[40px] w-[107px] bg-infinity-gradient rounded-[10px]"
                            >
                                <p className="text-[15px] text-white font-IRANYekanBold">{snipper ? "..." : text("ثبت", "Save")}</p>
                            </button>
                        </div>
                    </div>
                </div>

                {showErrorModalStep1 ? (
                    <>
                        <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="relative w-[50%] lg:w-[50%] sm:w-[95%] my-5 mx-auto max-w-3xl">
                                <div className="border-0 rounded-lg p-2 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                    <div className="flex items-start justify-between p-4 border-b border-solid border-b-midGray rounded-t">
                                        <span className="text-base font-bold text-red">{text("درخواست اشتباه!", "Unable to save")}</span>
                                    </div>
                                    <div className="relative px-4 py-1 flex-auto">
                                        <p className="my-4 text-black text-sm leading-relaxed">{error}</p>
                                    </div>
                                    <div className="flex items-center justify-end border-solid border-slate-200 rounded-b">
                                        <Link
                                            className="text-white mx-4 mb-2 rounded-md shadow-blueShadow bg-infinity-gradient font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                                            type="button"
                                            onClick={() => setShowErrorModalStep1(false)}
                                        >
                                            {text("فهمیدم", "Got it")}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </>
                ) : null}
            </div>

            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
    );
};

export default AddJobModal;
